export default __webpack_public_path__ + "static/star_w.8d105d075d3ee6df75cda797fa9029d8.png";